export default {
  locale: 'zh-CN',
  // common
  'common.more': '更多',
  'common.empty': '暂无数据',
  'common.loading': '加载中...',
  'common.checkAll': '全选',
  'common.filter': '筛选',
  'common.confirm': '确认',
  'common.reset': '重置',
  'common.search': '搜索',
  // pagination
  'pagination.goto': '前往',
  'pagination.page': '页',
  'pagination.countPerPage': '条/页',
  'pagination.total': '共 {0} 条',
  // upload
  'upload.buttonLabel': '点击上传',
  'upload.drag': '点击或拖拽文件到此处上传',
  'upload.dragHover': '释放文件并开始上传',
  'upload.retry': '点击重试',
  'upload.delete': '删除',
  'upload.preview': '预览',
  'upload.edit': '编辑',
  'upload.loading': '上传中',
  'upload.failed': '上传失败',
  'upload.download': '下载文件',
  // select
  'select.cancel': '取消',
  'select.confirm': '确定',
  // input
  'input.limit': '<b>{0}</b>/{1}',
  // table
  'table.filterEmptyOption': '空',
  'table.filterPlaceholder': '请输入搜索内容',
  // timePicker
  'timePicker.time': '时间',
  'timePicker.selectTime': '选择时间',
  'timePicker.placeholder': '请选择时间',
  'timePicker.now': '此刻',
  'timePicker.startTime': '开始时间',
  'timePicker.endTime': '结束时间',
  // datePicker
  'datePicker.date': '日期',
  'datePicker.time': '时间',
  'datePicker.selectDate': '选择日期',
  'datePicker.selectTime': '选择时间',
  'datePicker.placeholder': '请选择日期',
  'datePicker.yearPlaceholder': '请选择年份',
  'datePicker.monthPlaceholder': '请选择月份',
  'datePicker.today': '今天',
  'datePicker.year': '年',
  'datePicker.yearUnit': '年',
  'datePicker.monthUnit': '月',
  'datePicker.dayUnit': '日',
  'datePicker.weekdays.0': '日',
  'datePicker.weekdays.1': '一',
  'datePicker.weekdays.2': '二',
  'datePicker.weekdays.3': '三',
  'datePicker.weekdays.4': '四',
  'datePicker.weekdays.5': '五',
  'datePicker.weekdays.6': '六',
  'datePicker.months.0': '一月',
  'datePicker.months.1': '二月',
  'datePicker.months.2': '三月',
  'datePicker.months.3': '四月',
  'datePicker.months.4': '五月',
  'datePicker.months.5': '六月',
  'datePicker.months.6': '七月',
  'datePicker.months.7': '八月',
  'datePicker.months.8': '九月',
  'datePicker.months.9': '十月',
  'datePicker.months.10': '十一月',
  'datePicker.months.11': '十二月',
  'datePicker.monthsShort.0': '01月',
  'datePicker.monthsShort.1': '02月',
  'datePicker.monthsShort.2': '03月',
  'datePicker.monthsShort.3': '04月',
  'datePicker.monthsShort.4': '05月',
  'datePicker.monthsShort.5': '06月',
  'datePicker.monthsShort.6': '07月',
  'datePicker.monthsShort.7': '08月',
  'datePicker.monthsShort.8': '09月',
  'datePicker.monthsShort.9': '10月',
  'datePicker.monthsShort.10': '11月',
  'datePicker.monthsShort.11': '12月',
  // dateRangePicker
  'dateRangePicker.placeholderStart': '开始日期',
  'dateRangePicker.placeholderEnd': '结束日期',
  'dateRangePicker.selectRange': '选择日期范围',
} as const;
